import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { clinicQKeys } from "@hooks/queries/clinic/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  fileId: string;
  fileData: FormData;
}

export const useUpdateClinicFile = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ fileId, fileData }: MutationProps) => {
      return api.patch(`clinic/files/${fileId}`, fileData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "update-file-success",
      });
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.files(),
      });
    },

    onError: (res: any) => {
      console.error("[From Update Clinic File]", res);
      handleErrors(res, "mutation");
    },
  });
};
